type DateOnlyIso = `${number}-${number}-${number}`;

export const SCHOOL_LUNCH_BOX_ORDER_DELIVERY_TIMES = [
  "REGULAR_DELIVERY",
  "DELIVERY_CUTOFF_07_00",
  "DELIVERY_CUTOFF_07_30",
  "DELIVERY_CUTOFF_08_00",
  "DELIVERY_CUTOFF_08_30",
  "DELIVERY_CUTOFF_09_00",
  "DELIVERY_CUTOFF_09_30",
  "DELIVERY_CUTOFF_10_00",
  "DELIVERY_CUTOFF_10_30",
  "DELIVERY_CUTOFF_11_00",
] as const;

export type SchoolLunchBoxOrderDeliveryTime =
  (typeof SCHOOL_LUNCH_BOX_ORDER_DELIVERY_TIMES)[number];

export type SchoolLunchBoxOrder = {
  "@context": string;
  "@id": string;
  "@type": string;
  id: number;
  cafeteria?: string | null;
  schoolClass?: string | null;
  studentGroup?: string | null;
  quantity: number;
  deliveryDate: DateOnlyIso;
  deliveryTime: SchoolLunchBoxOrderDeliveryTime;
  lunchBox?: string | null;
  editedBy?: string | null;
  comment?: string | null;
  peopleWithAllergies?: string[];
  cancelledAt?: string | null;
};

export type SchoolLunchBoxOrderInput = {
  cafeteria: string;
  schoolClass?: string | null;
  studentGroup?: string | null;
  quantity: number;
  deliveryDate: DateOnlyIso;
  deliveryTime: SchoolLunchBoxOrderDeliveryTime;
  lunchBox: string;
  editedBy: string;
  comment?: string | null;
  peopleWithAllergies?: string[];
};
